import React, { Fragment, useEffect, useState } from 'react';
import classnames from 'classnames';
import { FiDownload } from 'react-icons/fi';

import Button from '../components/Button';

import { canGenerateImage, generateImage } from '../utils/graphs';

import grid from '../styles/grid.module.css';
import css from './Section.module.css';

export const Section = ({ id, children, forwardRef, className, ruler, saving }) => {
	return (
		<div
			id={id}
			ref={forwardRef}
			className={classnames(css.root, grid.root, {
				[css.ruler]: ruler,
				[className]: className,
				[css.saving]: saving,
			})}>
			{children}
		</div>
	);
};

export const Full = ({ children, title, forwardRef, filename, imageRef, setSaving, onDownloadData }) => {
	return (
		<Fragment>
			<div className={classnames(css.full, grid.column8)} ref={forwardRef}>
				{title && <h3>{title}</h3>}
				<div className={css.children}>{children}</div>
				{filename && onDownloadData ? (
					<Fragment>
						<a
							className={css.download}
							href="#"
							onClick={(e) => {
								e.preventDefault();
								onDownloadData(filename);
							}}>
							<FiDownload />
							<span>Download data</span>
						</a>
						<p className={css.disclaimer}>
							* Any use of this data in graphs or papers should cite "EuroMOMO (euromomo.eu){' '}
							{new Date().getFullYear()}". Filters applied to the graph will be applied to the downloaded
							data as well.
						</p>
					</Fragment>
				) : null}
				{filename && canGenerateImage ? (
					<a
						className={css.download}
						href="#"
						onClick={() => {
							generateImage(imageRef, 1600, filename, setSaving);
						}}>
						<FiDownload />
						<span>Download as image</span>
					</a>
				) : null}
			</div>
		</Fragment>
	);
};

export const Left = ({ children, filename, onDownloadData, imageRef, setSaving, forwardRef, sticky }) => {
	const content = (
		<Fragment>
			{children}
			{filename && onDownloadData ? (
				<Fragment>
					<a
						className={css.download}
						href="#"
						onClick={(e) => {
							e.preventDefault();
							onDownloadData(filename);
						}}>
						<FiDownload />
						<span>Download data</span>
					</a>
					<p className={css.disclaimer}>
						* Any use of this data in graphs or papers should cite "EuroMOMO (euromomo.eu){' '}
						{new Date().getFullYear()}". Filters applied to the graph will be applied to the downloaded data
						as well.
					</p>
				</Fragment>
			) : null}
			{filename && canGenerateImage ? (
				<a
					className={css.download}
					href="#"
					onClick={() => {
						generateImage(imageRef, 1600, filename, setSaving);
					}}>
					<FiDownload />
					<span>Download as image</span>
				</a>
			) : null}
		</Fragment>
	);
	return (
		<div className={classnames(css.left, grid.column2)} ref={forwardRef}>
			{sticky ? <Sticky>{content}</Sticky> : content}
		</div>
	);
};

export const Right = ({ children, forwardRef }) => {
	return (
		<div className={classnames(css.right, grid.column6)} ref={forwardRef}>
			{children}
		</div>
	);
};

export const Sticky = ({ children, row }) => {
	return (
		<div
			className={classnames(css.sticky, {
				[css.row]: row,
			})}>
			{children}
		</div>
	);
};

export default Section;
